
import { KeyValueModel } from "model";
import { EnumConviteStatus } from "model/enums/enum-convite-status";

export const StatusConviteMock: KeyValueModel[] = [
    new KeyValueModel(EnumConviteStatus.ATIVADO, "Ativado"),
    new KeyValueModel(EnumConviteStatus.BLOQUEADO, "Bloqueado"),
    new KeyValueModel(EnumConviteStatus.CONVIDADO, "Convidado"),
];
